/**
 * @desc create
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.InMasterCreateRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/inmaster/create`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
